var map = {
	"./poly-1.png": "dbeb",
	"./poly-10.png": "0425",
	"./poly-2.png": "8adc",
	"./poly-3.png": "f50e",
	"./poly-4.png": "d253",
	"./poly-5.png": "c8ec",
	"./poly-6.png": "39d7",
	"./poly-7.png": "a1fa",
	"./poly-8.png": "c549",
	"./poly-9.png": "43f6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "261c";